import React, { CSSProperties } from "react";
import cls from "./styles.module.scss";

interface SkeletonProps {
  /** высота полоски, px */
  height?: number;
  /** ширина: число — проценты, строка — как есть */
  width?: number | string;
  /** скругление, px */
  radius?: number;
  className?: string;
  style?: CSSProperties;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  height = 14,
  width = 100,
  radius,
  className,
  style,
}) => {
  const inline: CSSProperties = {
    height: `${height}px`,
    width: typeof width === "number" ? `${width}%` : width,
    ...(radius !== undefined ? { borderRadius: `${radius}px` } : {}),
    ...style,
  };

  return (
    <div
      className={className ? `${cls.skeleton} ${className}` : cls.skeleton}
      style={inline}
    />
  );
};

export default Skeleton;
